module.exports = __webpack_public_path__ + "img/box-3.59a6ccdf.png";